<template>
  <div>
    <slot />
  </div>
</template>

<script lang="ts" setup>
const { isMobile } = useDevice();
const route         = useRoute();

if (isMobile && !route.path.startsWith('/pc/')) {
  import('@/assets/scss/mo/import-hcon.scss');
  import('@/assets/scss/mo/mo-hcon.scss');
} else {
  import('@/assets/scss/pc/import-hcon.scss');
  import('@/assets/scss/pc/pc-hcon.scss');
}

</script>

<style lang="scss" scoped>
</style>